import AxiosConfig from '../utils/AxiosConfig';

// Los errores de entrada llegan como códigos (invalid_days, ...): la pantalla los muestra, no el cliente HTTP.
const quiet = { skipSnackbar: true, skipGlobalErrorRedirect: true };

// Reportes del superadmin: lecturas de la foto nocturna. Todas devuelven { freshness: { dataAsOf, computedAt }, ... }.
class CoreReportsService {
  async overview({ days = 30, granularity = 'day' } = {}) {
    const response = await AxiosConfig.get('/core/reports/overview', { ...quiet, params: { days, granularity } });
    return response.data.data;
  }

  async companies() {
    const response = await AxiosConfig.get('/core/reports/companies', quiet);
    return response.data.data;
  }

  async infra({ days = 30 } = {}) {
    const response = await AxiosConfig.get('/core/reports/infra', { ...quiet, params: { days } });
    return response.data.data;
  }

  // Salud operativa y auditoría se leen en vivo (no de la foto nocturna). Máximo 90 días.
  async health({ days = 7 } = {}) {
    const response = await AxiosConfig.get('/core/reports/health', { ...quiet, params: { days } });
    return response.data.data;
  }

  async audit({ days = 7, category = '', limit = 100 } = {}) {
    const params = { days, limit };
    if (category) params.category = category;
    const response = await AxiosConfig.get('/core/reports/audit', { ...quiet, params });
    return response.data.data;
  }

  async cfe({ days = 30 } = {}) {
    const response = await AxiosConfig.get('/core/reports/cfe', { ...quiet, params: { days } });
    return response.data.data;
  }
}

export default new CoreReportsService();
